import React from 'react';
import { motion } from 'framer-motion';
import { scrollToCompra } from '../lib/constants';
type CTAButtonProps = {
  label?: string;
  sub?: string;
  className?: string;
};
export function CTAButton({
  label = 'Resolvé tus clases hoy',
  sub,
  className = ''
}: CTAButtonProps) {
  return <motion.button type="button" onClick={scrollToCompra} whileTap={{
    scale: 0.97
  }} animate={{
    scale: [1, 1.02, 1]
  }} transition={{
    duration: 2.4,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className={`w-full rounded-xl bg-[#e8590c] px-5 py-4 text-center font-display text-base font-extrabold uppercase tracking-wide text-white shadow-lg shadow-orange-900/40 ring-1 ring-orange-300/30 transition-colors hover:bg-[#d24f08] focus:outline-none focus-visible:ring-4 focus-visible:ring-orange-300 ${className}`} data-id="element-64" data-mp="2fz22aptk92x3">
      <span className="block leading-tight" data-id="element-65" data-mp="38p1xfwy9f1mr">{label}</span>
      {sub ? <span className="mt-1 block text-[11px] font-medium normal-case tracking-normal text-orange-100" data-id="element-66" data-mp="198wk989rxg42">
          {sub}
        </span> : null}
    </motion.button>;
}